import _objectSpread from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/esnext.iterator.map.js";
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/enterprise.svg';
import _imports_1 from '../../../assets/image/no-more.svg';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4695ecca"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "infoBox"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "ind-icon"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })], -1);
});
var _hoisted_3 = {
  key: 1,
  class: "no-more"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});
var _hoisted_5 = {
  class: "paging"
};
import info from '@/api/info';
import { $rdoLang } from '@/assets/common/common.js';
import industryInfo from '@/components/industryinfo/index.vue';
import { VueCookieNext } from 'vue-cookie-next';
import { useLang } from '../../../hooks/lang';
export default {
  setup: function setup(__props) {
    // import { useLang } from '@/hooks/lang';
    var _useLang = useLang(),
      $t = _useLang.$t;
    var industries = ref([]);
    var total = ref(0);
    var totalPage = ref(1);
    var zIndex = ref(0);
    var changeZindex = function changeZindex(val) {
      console.log(val);
      zIndex.value = val;
    };
    loadList(1);

    // 获取行业信息列表
    function loadList(pageIndex) {
      var params = {
        lang: $rdoLang(VueCookieNext.getCookie('lang')),
        page: pageIndex,
        pageSize: 2
      };
      info.getCompanyList(params).then(function (res) {
        totalPage.value = res.pageInfo.pages;
        total.value = res.pageInfo.total;
        industries.value = res.result.map(function (val, ind) {
          return _objectSpread(_objectSpread({}, val), {}, {
            index: ind
          });
        });
      });
    }

    // 切换tab页面
    function changePage(pageindex) {
      console.log('pindex==', pageindex);
      loadList(pageindex);
    }
    return function (_ctx, _cache) {
      var _component_el_row = _resolveComponent("el-row");
      var _component_el_card = _resolveComponent("el-card");
      var _component_el_col = _resolveComponent("el-col");
      var _component_el_pagination = _resolveComponent("el-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        class: "title"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_unref($t)('industryInfo.industryInfoText')), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(function () {
          return [total.value > 0 ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            class: "industries"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industries.value, function (item) {
                return _openBlock(), _createBlock(_component_el_card, {
                  key: item.id,
                  class: "box-card",
                  "body-style": {
                    padding: '0px'
                  },
                  shadow: "never"
                }, {
                  default: _withCtx(function () {
                    return [_hoisted_2, _createVNode(industryInfo, {
                      zIndex: zIndex.value,
                      onChangeZindex: changeZindex,
                      info: item,
                      from: "user"
                    }, null, 8, ["zIndex", "info"])];
                  }),
                  _: 2
                }, 1024);
              }), 128))];
            }),
            _: 1
          })) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", null, _toDisplayString(_unref($t)('common.noData')), 1)]))];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_5, [total.value > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
        key: 0,
        background: "",
        layout: "prev, pager, next",
        onCurrentChange: changePage,
        "page-count": totalPage.value
      }, null, 8, ["page-count"])) : _createCommentVNode("", true)])]);
    };
  }
};